module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), (_vm.exibirGrafico) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Monitoramentos (%)")]), _vm._v(" "), _c('va-chart', {
    attrs: {
      "chart-config": _vm.relatorios.producao
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('h3', [_vm._v("Requisitos de pesquisa")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataInicioBusca"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data inicial",
      "id": "dataInicioBusca"
    },
    model: {
      value: (_vm.dataInicioBusca),
      callback: function($$v) {
        _vm.dataInicioBusca = $$v
      },
      expression: "dataInicioBusca"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataFimBusca"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "placeholder": "Selecione a data final",
      "id": "dataFimBusca"
    },
    model: {
      value: (_vm.dataFimBusca),
      callback: function($$v) {
        _vm.dataFimBusca = $$v
      },
      expression: "dataFimBusca"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group col-sm-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "checkbox",
    attrs: {
      "id": "dados"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosOperando),
      expression: "pesquisa.isDadosOperando"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosOperando) ? _vm._i(_vm.pesquisa.isDadosOperando, null) > -1 : (_vm.pesquisa.isDadosOperando)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosOperando,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosOperando", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosOperando", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosOperando", $$c)
        }
      }
    }
  }), _vm._v("\n                  Operando\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosFuncao),
      expression: "pesquisa.isDadosFuncao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosFuncao) ? _vm._i(_vm.pesquisa.isDadosFuncao, null) > -1 : (_vm.pesquisa.isDadosFuncao)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosFuncao,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosFuncao", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosFuncao", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosFuncao", $$c)
        }
      }
    }
  }), _vm._v("\n                  Função\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosParadosComOrdem),
      expression: "pesquisa.isDadosParadosComOrdem"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosParadosComOrdem) ? _vm._i(_vm.pesquisa.isDadosParadosComOrdem, null) > -1 : (_vm.pesquisa.isDadosParadosComOrdem)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosParadosComOrdem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosParadosComOrdem", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosParadosComOrdem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosParadosComOrdem", $$c)
        }
      }
    }
  }), _vm._v("\n                  Parados com Ordem\n                ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.isDadosParadosSemOrdem),
      expression: "pesquisa.isDadosParadosSemOrdem"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.pesquisa.isDadosParadosSemOrdem) ? _vm._i(_vm.pesquisa.isDadosParadosSemOrdem, null) > -1 : (_vm.pesquisa.isDadosParadosSemOrdem)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.pesquisa.isDadosParadosSemOrdem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.pesquisa, "isDadosParadosSemOrdem", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.pesquisa, "isDadosParadosSemOrdem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.pesquisa, "isDadosParadosSemOrdem", $$c)
        }
      }
    }
  }), _vm._v("\n                  Parados sem Ordem\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "maquinas"
    }
  }, [_vm._v("Máquina")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idcontrolador),
      expression: "pesquisa.idcontrolador"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "maquinas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idcontrolador", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione a Máquina")]), _vm._v(" "), _vm._l((_vm.monitores), function(monitor) {
    return _c('option', {
      key: monitor.id,
      domProps: {
        "value": monitor.id
      }
    }, [_vm._v(_vm._s(monitor.nomemaquina))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "turnos"
    }
  }, [_vm._v("Turno")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.idTurnoSelecionado),
      expression: "pesquisa.idTurnoSelecionado"
    }],
    staticClass: "form-control col-sm-4",
    attrs: {
      "id": "turnos"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.pesquisa, "idTurnoSelecionado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Selecione o Turno")]), _vm._v(" "), _vm._l((_vm.turnos), function(turno) {
    return _c('option', {
      key: turno.id,
      domProps: {
        "value": turno.id
      }
    }, [_vm._v(_vm._s(turno.nometurno))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [(_vm.pesquisa.isDadosDisponiveis || _vm.pesquisa.isDadosOperando || _vm.pesquisa.isDadosFuncao || _vm.pesquisa.isDadosOutros) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.efetuarPesquisa()
      }
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v("\n              Efetuar Pesquisa\n            ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-8 control-label",
    attrs: {
      "for": "dados"
    }
  }, [_vm._v("Tipo de Dados")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52834c43"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RelatoriosProducao.vue
// module id = 636
// module chunks = 1